let sdk = null;
let channelId = null;

const enableWebSdk = async (options = {}) => {
	if (typeof UA === "undefined") {
		return;
	}

	if (sdk === null) {
		sdk = await UA;
		channelId = (await sdk.create())?.channelId || null;
	}

	const { pushNotifications = false } = options;

	if (pushNotifications === true && (await sdk.canRegister())) {
		await sdk.register();
	}

	return { channelId, sdk };
};

export default enableWebSdk;
